export default {
    api: {
        baseUrl: process.env.API_URL,
    },
    helmet: {
        title: 'SmartClinic',
        titleTemplate: 'SmartClinic',
        htmlAttributes: {
            lang: 'es',
        },
        meta: [
            {
                name: 'description',
                content: 'SmartClinic Alma',
            },
        ],
    },
    cookies: {
        access_token: 'access_token',
        language: 'language',
    },
    server: {
        host: process.env.HOST,
        port: process.env.PORT,
        sslPort: process.env.SSL_PORT,
    },
};
